
import csv from "csvtojson";
import { defineComponent, ref } from "vue";
import { ElMessage } from "element-plus";
import { UploadFile } from "element-plus";
import { AppError, AppRole } from "@/types/app.type";
import { Parameter } from "@/types/parameter.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { getParameter } from "@/service/parameter.service";
import { getSamplingPointNames } from "@/service/samplingpoint.service";
import { getDatesWithEstimations } from "@/service/estimation.service";
import ValidateListTableComponent from "@/components/validation/ValidateListTableExample.component.vue";
import ValidationInfoDialogComponent from "@/components/information/ValidationInfoDialog.component.vue";
import { Estimation, Validation } from "@/types/estimation.type";
import { Pagination } from "@/types/pagination.type";
import UploadHeaderComponent from "@/components/uploader/UploadHeader_2.component.vue";
import { dateFormatFile, getDate } from "@/utils/date.utils";
import { DataUpload } from "@/types/dataupload.type";
import ValidationResultComponent from "@/components/validation/ValidationResultExample.component.vue";
import { Filter } from "@/types/filter.type";

// ValidateListGraphComponent,
export default defineComponent({
  components: {
    ValidateListTableComponent,
    UploadHeaderComponent,
    ValidationResultComponent,
    ValidationInfoDialogComponent,
  },
  data() {
    return {
      //graphTable: "graph" as string,
      graphTable: "table" as string,
      visualize: undefined as string | undefined,
      samplingPoint: undefined as string | undefined,

      selectedSamPoint: {} as SamplingPoint, // selectedSamPoint
      selectedParameter: {} as Parameter, // Parameter
      dataValidation: {} as Pagination<Validation>,

      form: {
        file: [] as Array<{ name: string; url: string | ArrayBuffer | null | undefined }>,
      },
      dataFile: "" as string | undefined,
      visibleCheck: false,
      headerFile: [] as string[],
      headerParameter: [] as string[],
      saveParameter: [] as Parameter[],

      infoVisible: false,

      samplingpoints: [] as SamplingPoint[],
      parameters: [] as Parameter[] | undefined,
      disableParameter: true as boolean,
      disableDate: true as boolean,
      paramLength: undefined as number | undefined,
      startDate: undefined as Date | undefined,
      endDate: undefined as Date | undefined,
      datesWithEstimations: [] as string[],
      rules: {
        selectedSamPoint: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        selectedParameter: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        startDate: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        file: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
      },

      headerP: [] as Parameter[],
      loadingUpload: false,
      difference: 0,
      activeName: ref("first"),
      loading: false,
      dataUpload: [] as DataUpload[],
      estimations: [] as Estimation[],
    };
  },
  async mounted() {
    this.samplingpoints = await getSamplingPointNames();
  },
  methods: {
    async putParameters(samPoint: SamplingPoint) {
      // if (!samPoint.hasAllParameters) {
      //   this.parameters = samPoint.parameters;
      // } else {
      let filter: Filter = {
        fields: {
          "parameter.active": { operator: "equal", value: true },
          "parameter.client": { operator: "equal", value: false },
          "parameter.type": { operator: "equal", value: "SAMPLINGPOINT" },
        },
        multi: undefined,
      };
      const param = await getParameter(undefined, undefined, filter);
      this.parameters = param.data;
      //}

      this.selectedParameter = {} as Parameter;
      if (this.selectedSamPoint.id !== undefined) {
        this.disableParameter = false;
      }
    },

    /**
     * Saber cunado hay estimación
     * @param day
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hasEstimatedData(day: Date) {
      return this.datesWithEstimations.includes(day.toDateString());
    },

    // GET FILE HEADER
    /**
     *
     * @param firstLine
     */
    header(firstLine: any) {
      const header = [];
      for (let i of Object.entries(firstLine)) {
        header.push(i[0]);
      }
      return header;
    },

    initializeHeader() {
      if (this.parameters) {
        let match = false;
        for (let index of this.headerFile) {
          if (index === this.selectedParameter.name) match = true;
          const magnitude = index.toLowerCase();
          let paramHeader: Parameter | undefined;
          for (let parameter of this.parameters) {
            if (parameter.name && magnitude.includes(parameter.name.toLowerCase())) {
              paramHeader = parameter;
            }
          }
          if (paramHeader && paramHeader.name) {
            this.headerP.push(paramHeader);
          } else if (magnitude.includes("fecha")) {
            continue;
          } else {
            ElMessage.error(this.$t("error.notParameter", { name: magnitude }));
            throw new Error(AppError.FORM_VALIDATION);
          }
        }
        if (!match) {
          this.removeFile();
          ElMessage.error(this.$t("error.notSelected"));
          throw new Error(AppError.FORM_VALIDATION);
        }

        this.visibleCheck = true;
      }
    },

    removeFile() {
      this.form.file = [] as Array<{
        name: string;
        url: string | ArrayBuffer | null | undefined;
      }>;
    },
    /**
     * Detectar la cabecera y el rango de fechas del excel
     * @param file
     */
    async handleChange(file: UploadFile) {
      this.dataFile = await file.raw?.text();

      if (this.startDate && this.endDate) {
        if (this.dataFile) {
          const csvObj = await csv({ delimiter: "auto" }).fromString(this.dataFile);
          const fromDateObj = Object.entries(csvObj[0]);
          const toDateObj = Object.entries(csvObj[csvObj.length - 1]);
          const fromDate = fromDateObj[0][1] as string;
          const toDate = toDateObj[0][1] as string;

          // Convertir las fechas de inicio y fin del archivo CSV a objetos Date (no usar)
          // this.startDate = getDate(fromDate, "Europe/Madrid");
          // this.endDate = getDate(toDate, "Europe/Madrid");
          // this.headerFile = this.header(csvObj[0]);
          // this.initializeHeader();
          if (
            this.startDate >= getDate(fromDate, "Europe/Madrid") &&
            this.startDate < getDate(toDate, "Europe/Madrid") &&
            this.endDate > getDate(fromDate, "Europe/Madrid") &&
            this.endDate <= getDate(toDate, "Europe/Madrid")
          ) {
            this.headerFile = this.header(csvObj[0]);
            this.initializeHeader();
          } else {
            this.removeFile();
            ElMessage.error(this.$t("error.notInside"));
            throw new Error(AppError.FORM_VALIDATION);
          }
        }
      } else {
        this.removeFile();
        ElMessage.error(this.$t("error.notRangeDate"));
        throw new Error(AppError.FORM_VALIDATION);
      }
    },

    handleRemove() {
      this.headerParameter = [];
      this.headerP = [] as Parameter[];
      this.$emit("remove");
    },

    /**
     * Btn- Visualizar
     */
    async visualizeData() {
      this.loading = true;

      if (
        this.selectedSamPoint === undefined ||
        this.selectedParameter === undefined ||
        this.startDate === undefined ||
        this.endDate === undefined
      ) {
        ElMessage.error(this.$t("error.required"));
      } else if (this.startDate > this.endDate) {
        ElMessage.error(this.$t("error.wrongDate"));
      } else {
        // const diffDate = moment(this.endDate).diff(moment(this.startDate), "days");
        this.dataValidation = {} as Pagination<Validation>;

        this.dataUpload = (await this.uploadData()) as DataUpload[];

        this.loadingUpload = true;
        this.visualize = this.graphTable;
      }
      this.loading = false;
    },

    /**
     * Cargar datos
     */
    async uploadData() {
      if (this.dataFile) {
        const csvObj_2 = await csv({
          delimiter: "auto",
          headers: this.headerParameter,
          trim: true,
          ignoreEmpty: true,
        }).fromString(this.dataFile);
        this.generatedSaveParameter();
        return this.parseDataUpload(csvObj_2);
      }
    },

    generatedSaveParameter() {
      if (this.parameters) {
        this.saveParameter.shift();
        for (let i of this.parameters) {
          if (i.code) {
            if (this.headerParameter.find((code) => code === i.code)) {
              const index = this.headerParameter.indexOf(i.code);
              this.saveParameter[index] = i;
            }
          }
        }
      }
    },

    /**
     * Importar datos
     */
    parseDataUpload(data: any[]) {
      let dataUpload: DataUpload[] = [];

      if (this.headerP.length > 0 && this.startDate && this.endDate) {
        for (let line of data) {
          if (line.length !== 0) {
            const arrayLine = Object.entries(line);

            for (let i = 0; i < this.headerP.length; i++) {
              // controlar
              const { date, value } = this.generateUpload(i, arrayLine);

              if (
                date !== "Invalid date" &&
                date &&
                this.headerP[i] &&
                value !== 0 &&
                new Date(date) >= this.startDate &&
                new Date(date) <= this.endDate
              ) {
                const item = {
                  dateTime: date,
                  magnitude: this.headerP[i].name,
                  value: value,
                  parameter: this.headerP[i],
                  unit: this.headerP[i].unit,
                  samplingPoint: this.selectedSamPoint,
                  origin: "",
                } as DataUpload;

                dataUpload.push(item);
              }
            }
          }
        }
      }

      return dataUpload;
    },

    async getMarkedDates() {
      if (this.selectedSamPoint.id && this.selectedParameter.id) {
        await getDatesWithEstimations([this.selectedSamPoint.id], [this.selectedParameter.id]).then(
          (response) => {
            this.datesWithEstimations = response.map((_) => new Date(_.image_date).toDateString());
          }
        );
      }
    },
    checkParameter() {
      if (this.selectedParameter.id !== undefined) {
        this.disableDate = false;
      }
    },

    async createForm() {
      this.visibleCheck = false;
    },

    closeFormDialog() {
      this.visibleCheck = false;
      this.headerP = [] as Parameter[];
    },

    generateUpload(i: number, arrayLine: any) {
      let date = undefined;
      if (dateFormatFile(arrayLine[0][1] as string, "Europe/Madrid")) {
        date = dateFormatFile(arrayLine[0][1] as string, "Europe/Madrid");
      }
      // let magnitude = arrayLine[i][0];
      let valueString = arrayLine[i + 1][1];
      const value = this.parseNumber(valueString);

      return { date, value };
    },

    parseNumber(valueString: string) {
      let value = Number(valueString.replace(/,/g, "."));
      if (isNaN(value)) {
        value = 0;
      }
      return value;
    },
    openInfoDialog() {
      this.infoVisible = true;
    },

    disabledData(date: Date) {
      if (!this.datesWithEstimations.includes(date.toDateString())) {
        return true;
      } else {
        return false;
      }
    },

    isDisabled() {
      if (
        this.selectedSamPoint &&
        this.selectedParameter &&
        this.startDate &&
        this.endDate &&
        this.form.file.length > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    selectedSamPoint: {
      immediate: true,
      async handler(selectedSamPoint) {
        if (selectedSamPoint && this.selectedParameter) {
          this.getMarkedDates();
        }
      },
    },
    selectedParameter: {
      immediate: true,
      async handler(selectedParameter) {
        if (selectedParameter && this.selectedSamPoint) {
          this.getMarkedDates();
        }
      },
    },
  },
});
